export default "__VITE_PUBLIC_ASSET__6fdbe563__"